export function quoteSlider() {
    const $slider = $(".quote-slider");
    $slider.find("blockquote").attr("tabindex", "-1");
    $slider.on('init', function (event, slick) {
        slick.$nextArrow.attr("aria-label", "View Next Quote")
        slick.$prevArrow.attr("aria-label", "View Previous Quote")


    });
    $slider.slick({
        slidesToScroll: 1,
        slidesToShow: 1
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        const $slides = $(slick.$slides);
        $slides.find("blockquote").attr("tabindex", "-1");
    }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
        const $slides = $(slick.$slides);
        $slides.eq(currentSlide).find("blockquote").attr("tabindex", "0").focus();
    });
    $slider.find("blockquote").focusout(function () {
        $(this).removeAttr("tabindex");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/quoteSlider.js